import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import { schema } from '../../../../../state/schema';
import {
  loadModuleCategoriesAdmin,
  createModuleCategoryAdmin,
} from '../../../../../state/modules/learningsAdmin/actions';
import ModuleCategoryInputRow from '../components/ModuleCategoryInputRow';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const defaultLimit = 20;
const defaultOrder = 'name.asc';

const mapStateToProps = (state, ownProps) => {
  const partnershipId = storage.get(findStorageType(), 'partnershipId');

  // merge results for all modules
  const results = [].concat.apply(
    [],
    Object.entries(
      state.learningsAdmin.getIn(
        [
          'moduleCategoriesAdmin',
          partnershipId,
          'pages',
          defaultOrder,
          defaultLimit,
        ],
        {}
      )
    ).map(([k, v]) => v.toArray())
  );

  const list =
    results.length > 0
      ? results.map((x) => {
          return {
            ...denormalize(
              state.entities.getIn(['learningModuleCategoriesAdmin', x]),
              schema.learningModuleCategoryAdmin,
              state.entities.toJS()
            ),
          };
        })
      : [];

  return {
    options: list,
    isLoading: state.learningsAdmin.get('isLoading'),
    partnershipId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    create: (data, cb) => {
      dispatch(createModuleCategoryAdmin(data, cb));
    },
    load: (
      partnershipId,
      page = 1,
      limit = defaultLimit,
      order = defaultOrder,
      filter = {},
      cb = function () {}
    ) => {
      dispatch(
        loadModuleCategoriesAdmin(
          partnershipId,
          page,
          limit,
          order,
          filter,
          (success, total) => {
            if (success) {
              // loop over all pages to get all events
              const pageCount = Math.ceil(total / limit);
              for (var i = 2; i <= pageCount; i++) {
                dispatch(
                  loadModuleCategoriesAdmin(
                    partnershipId,
                    i,
                    limit,
                    order,
                    filter
                  )
                );
              }
              cb();
            }
          }
        )
      );
    },
  };
};

const ModuleCategoryInputRowContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ModuleCategoryInputRow);

export default ModuleCategoryInputRowContainer;
